import { Channel } from '@connect-x-app/shared-domain-models';

export const categorizeChannels = (channels: Channel[], isUserPartOfChannel: (channel: Channel) => boolean) =>
  channels.reduce<{ myChannels: Channel[]; otherChannels: Channel[] }>(
    (acc, channel) => {
      if (isUserPartOfChannel(channel)) {
        acc.myChannels.push(channel);
      } else {
        acc.otherChannels.push(channel);
      }
      return acc;
    },
    { myChannels: [], otherChannels: [] },
  );

export const hasMemberChannelUnread = (channels: Channel[], isUserPartOfChannel: (channel: Channel) => boolean): boolean =>
  channels.some(channel => isUserPartOfChannel(channel) && (channel.unreadMessagesCount ?? 0) > 0);
